import defaultProfile from '../assets/images/noProfileImage.png';
import Config from '../config';
import generateValidUrl from './fetch/generateValidUrl';

/**
 * Resolves a chat/profile avatar URL.
 *
 * The backend can return an empty/missing picture (e.g. the automated "support"
 * welcome conversation). In that case `generateValidUrl` would fall back to the
 * site base URL (an HTML page), which makes the <img> render as a broken image.
 * Here we short-circuit any empty / fallback value to a real placeholder asset.
 */
export function getAvatarSrc(photo: string | undefined | null): string {
    const trimmed = typeof photo === 'string' ? photo.trim() : '';

    if (!trimmed || trimmed === Config.FALLBACK_IMAGE) {
        return defaultProfile;
    }

    return generateValidUrl(trimmed);
}

/**
 * onError handler for avatar <img> elements: swaps to the placeholder once if the
 * resolved URL fails to load, guarding against an infinite error loop.
 */
export function handleAvatarError(event: React.SyntheticEvent<HTMLImageElement>): void {
    const img = event.currentTarget;
    if (img.dataset.fallbackApplied) {
        return;
    }
    img.dataset.fallbackApplied = 'true';
    img.src = defaultProfile;
}

export { defaultProfile };

export default getAvatarSrc;
